export enum FileCountersignStatus {
  NOT_READY = 'NOT_READY',
  WAIT = 'WAIT',
  NOT_NEED = 'NOT_NEED',
  STARTED = 'STARTED',
  FINISH = 'FINISH',
}
